var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXfinityDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 32,
    viewBox: "0 0 96 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1045_1325",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1582 15.9412L17.2643 7.20847H12.7867L9.01055 12.7766L5.23743 7.20847H0.755148L6.85668 15.9412L0.327148 25.2998H4.80792L9.01055 19.1028L17.7418 31.6758H22.0402L11.1582 15.9412ZM95.8395 7.20847H91.6245L85.3592 18.7354L81.0731 7.20847H77.0235L83.0431 22.9819L78.3863 31.6758H82.51L95.8395 7.20847ZM21.0962 7.20847H19.2529L17.1176 10.2844H21.0962V25.2998H25.0021V10.2844H28.9869V7.20847H25.0021V5.45725C25.0021 4.1341 25.5506 3.59551 26.8763 3.59551C27.638 3.59551 28.4276 3.74649 28.9869 3.89904V0.731291C28.1865 0.441755 27.0756 0.253389 25.8705 0.253389C22.8792 0.253389 21.0962 2.22566 21.0962 5.51485V7.20847ZM68.113 10.2844V20.3963C68.113 23.6964 69.8929 25.6516 72.878 25.6516C73.8684 25.6516 74.8526 25.5317 75.5973 25.2998L76.0686 22.16C75.8446 22.2161 75.0272 22.4138 74.3041 22.4138C72.6787 22.4138 72.0097 21.7568 72.0097 20.127V10.2844H76.4997L75.3332 7.20847H72.0097V0.675234L68.113 2.67241V7.20847H65.27V10.2844H68.113ZM48.0378 6.84734C46.2007 6.84734 44.4485 7.62409 43.54 8.84138V7.20847H39.634V25.2998H43.54V14.7411C43.54 11.8084 44.7977 10.1879 47.0875 10.1879C49.5735 10.1879 50.635 11.6543 50.635 15.0835V25.2998H54.5317V14.9465C54.5317 9.64461 52.2929 6.84734 48.0378 6.84734ZM35.4608 24.2833V7.20847H31.5548V25.2998H35.4608V24.2833ZM62.4487 24.2833V7.20847H58.5258V25.2998H62.4487V24.2833Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1045_1325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.245 0.387259H95.8395V31.6758H-3.245V0.387259Z",
    fill: "#0E0E0E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXfinityDark);
export default __webpack_public_path__ + "static/media/xfinity-dark.adca3d56e7f280f5fa347bb33b73043e.svg";
export { ForwardRef as ReactComponent };